import 'css-chunksrc/client/scenes/projectReportSubmission/indicatorsForm/styles.scss';export default {
  "indicatorsForm": "_indicatorsForm_y75ja_1",
  "input": "_input_y75ja_10",
  "indicator": "_indicator_y75ja_1",
  "name": "_name_y75ja_27"
};